import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ModifiersSettings, ModifiersItem, LimitContainer, Container } from './App.styles';
import { QueryArguments, Extraction, GroupBy, OrderBy, Interval, Limit, FunnelSteps, Filters } from './components';
import { showField } from './utils';
import { getEventCollection, getAnalysis, getFilters, removeFilter, addFilter, setFilters, updateFilter } from './modules/query';

var App = function App() {
  var dispatch = useDispatch();
  var analysis = useSelector(getAnalysis);
  var collection = useSelector(getEventCollection);
  var filters = useSelector(getFilters);
  var modifiersItemSettings = {
    width: {
      xs: '100%',
      md: 'auto'
    }
  };
  var showOrderBy = showField('orderBy', analysis);
  var showLimit = showField('limit', analysis);
  return React.createElement(Container, null, React.createElement(QueryArguments, null), analysis === 'extraction' && React.createElement(Extraction, {
    collection: collection
  }), showField('filters', analysis) && React.createElement(Filters, {
    collection: collection,
    filters: filters,
    onReset: function onReset() {
      return dispatch(setFilters([]));
    },
    onRemove: function onRemove(id) {
      return dispatch(removeFilter(id));
    },
    onChange: function onChange(id, filter) {
      return dispatch(updateFilter(id, filter));
    },
    onClick: function onClick(id) {
      return dispatch(addFilter(id));
    }
  }), showField('steps', analysis) && React.createElement(FunnelSteps, null), !showField('steps', analysis) && React.createElement(React.Fragment, null, showField('groupBy', analysis) && React.createElement(ModifiersItem, Object.assign({}, modifiersItemSettings), React.createElement(GroupBy, {
    collection: collection
  })), (showLimit || showOrderBy) && React.createElement(ModifiersSettings, {
    flexDirection: {
      xs: 'column',
      md: 'row'
    }
  }, showOrderBy && React.createElement(ModifiersItem, Object.assign({}, modifiersItemSettings), React.createElement(OrderBy, {
    collection: collection
  })), showLimit && React.createElement(LimitContainer, null, React.createElement(Limit, {
    collection: collection
  }))), showField('interval', analysis) && React.createElement(Interval, null)));
};

export default App;